<template>
  <div class="page-back" :style="style">
    <img v-show="backState" @click="back" src="./back.png" />
  </div>
</template>

<script>
  export default {
    name: "page-back",

    computed: {
      backState() {
        return this.controlShow && this.shouldShow;
      }
    },

    data: () => {
      return {
        controlShow: false,
        // 控制显示状态
        shouldShow: false,

        minLength: 0,

        style: {
          zIndex: 100,
        }
      }
    },

    methods: {
      show(options) {
        this.controlShow = true;
        this.minLength = options.minLength || 0;
        this.style.zIndex = options.zIndex || 100;
      },

      // 更新显示状态
      update(routers) {
        this.shouldShow = routers.length() > this.minLength;
      },

      // 后退
      back() {
        window.history.back(-1);
      },
    },
  }
</script>
<style scoped lang="less">
.page-back {
   pointer-events: none;
   z-index: 100;
   position: fixed;
   top: 20px;
   left: 20px;
   width: 40px;
   height: 40px;

   img {
     pointer-events: auto;
     width: 100%;
     height: 100%;
   }
   
 }
</style>
